<template>
	<div class="overview">
		<NavBer></NavBer>
		<div class="bg1">
			<img src="../assets/images/index/index06.jpg" alt="" />
		</div>
		<div class="w content" style="display: flex; justify-content: center;">
			<el-form
				:model="ruleForm"
				:rules="rules"
				ref="ruleForm"
				label-width="100px"
				class="demo-ruleForm"
				size="mini"
			>
				<el-form-item label="联系人" prop="name">
					<el-input style="width: 300px;" v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input style="width: 300px;" v-model="ruleForm.phone"></el-input>
				</el-form-item>

				<el-form-item label="内容说明" prop="notes">
					<el-input
						style="width: 300px;"
						type="textarea"
						:rows="4"
						v-model="ruleForm.notes"
					></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
					<el-button @click="resetForm('ruleForm')">清空</el-button>
				</el-form-item>
			</el-form>
		</div>
		<Footbar></Footbar>
	</div>
</template>

<script>
import NavBer from "../components/nav";
import Footbar from "../components/footbar";
export default {
	components: {
		NavBer,
		Footbar,
	},
	data() {
		var checkPhone = (rule, value, callback) => {
			// 手机号验证
			if (!value) {
				return callback(new Error("手机号不能为空"));
			} else {
				const reg = /^1[3456789]\d{9}$/;
				if (reg.test(value)) {
					callback();
				} else {
					return callback(new Error("请输入正确的手机号"));
				}
			}
		};

		return {
			ruleForm: {
				name: "",
				phone: "",
				notes: "",
			},
			rules: {
				name: [{ required: true, message: "请输入名称", trigger: "blur" }],
				phone: [
					{ required: true, message: "请输入正确的手机号", trigger: "blur" },
					{ validator: checkPhone, trigger: "blur" },
				],

				notes: [{ required: true, message: "请输入内容说明", trigger: "blur" }],
			},
			dialogType: 1,
			nameType: "",
		};
	},
	methods: {
		submitForm(formName) {
			
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// this.nameType = this.ruleForm.phone;
					// this.dialogFormVisible = false;
					// //手机号存到本地
					// localStorage.setItem("nameType", this.ruleForm.phone);
					//提交成功
					this.$message({
						showClose: true,
						message: "提交成功",
						type: "success",
						offset: 120,
					});
					this.ruleForm = {
						name: "",
						phone: "",
						notes: "",
					};
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
	},
};
</script>

<style scoped>
.overview {
	padding-top: 90px;
}
.bg1 {
	width: 100%;
	height: 400px;
	margin-bottom: 10px;
}
.bg1 img {
	width: 100%;
	height: 100%;
}
.content {
	margin-top: 60px;
}
.profile,
.culture {
	width: 100%;
	/* height: 300px; */
	text-align: center;
	background: -webkit-linear-gradient(top left, #f0ff00, #58cffb);
	padding-top: 50px;
	padding-bottom: 100px;
}
.profile h2 {
	color: #333;
}
.profile h3 {
	color: #130cb7;
}
.profile p {
	width: 400px;
	margin: 30px auto 10px;
}

.culture {
	background: -webkit-linear-gradient(top left, #43cbff, #9708cc);
}
.culture h2 {
	color: #333;
}
.culture h3 {
	color: #130cb7;
}
.culture p {
	width: 400px;
	margin: 30px auto 10px;
}
.el-row {
	margin-bottom: 20px;
}
.el-col {
	border-radius: 4px;
}
.grid-content {
	border-radius: 4px;
	min-height: 300px;
}
.contenttext {
	width: 500px;
	margin: 30px auto 10px;
	color: #fff;
	text-align: left;
	padding-left: 200px;
}
</style>
